import { installRouteLoader } from 'logard';
import { createRouter, createWebHistory } from 'vue-router';
import auditAccessRoutes from '@/audit-access/routes';
import bookingRoutes from '@/booking/routes';
import dossierRoutes from '@/dossier/routes';
import jobRoutes from '@/jobs/routes';
import loginRoutes from '@/login/routes';
import plannerRoutes from '@/planner/routes';
import satisfactionRoutes from '@/satisfaction/routes';
import statusBoardRoutes from '@/statusBoard/routes';
import tasksRoutes from '@/tasks/routes';
import testRoutes from '@/test/routes';
import workPreparationsRoutes from '@/workPreparation/routes';
import generalRoutes from '../routes';
import setupAuthenticationGuard from './guards/authentication';
import setupAuthorizationGuard from './guards/authorization';
import setupErrorHandler from './guards/error';
import setupFetchGuard from './guards/fetch';
import setupHistoryHook from './guards/history';
import setupInitGuard from './guards/init';
import setupTitleGuard from './guards/title';
import setupTransitionGuard from './guards/transition';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    bookingRoutes,
    loginRoutes,
    plannerRoutes,
    tasksRoutes,
    dossierRoutes,
    jobRoutes,
    statusBoardRoutes,
    workPreparationsRoutes,
    satisfactionRoutes,
    auditAccessRoutes,
    testRoutes,
    generalRoutes,
  ].flat(),
  scrollBehavior(to) {
    // when logging in with a Microsoft account we should ignore the hash in the URL here
    if (to.hash?.startsWith('#') && !to.hash.includes('code=')) {
      document.querySelector(to.hash)?.scrollIntoView({ behavior: 'instant' });
      return false;
    }
    return { top: 0 };
  },
});

setupErrorHandler(router);
setupTransitionGuard(router);
setupInitGuard(router);
setupAuthenticationGuard(router);
setupAuthorizationGuard(router);
installRouteLoader(router, { debug: import.meta.env.DEV });
setupFetchGuard(router);
setupHistoryHook(router);
setupTitleGuard(router);

export default router;
